import React from "react";
import { money } from "../helpers";
import TH from "./TH";
import TD from "./TD";
import type { PD7AData } from "../types";

interface PaymentsTableProps {
  pd7a: PD7AData | null | undefined;
}

export default function PaymentsTable({ pd7a }: PaymentsTableProps) {
  const hasData = !!pd7a && (pd7a.paycheque_count || 0) > 0;

  const statusLabel =
    pd7a?.status === "ready_to_pay"
      ? "Ready to pay"
      : pd7a?.status === "overdue"
      ? "Overdue"
      : "Waiting";

  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead>
        <tr>
          <TH>Tax type</TH>
          <TH>Period</TH>
          <TH>Payment status</TH>
          <TH>Amount</TH>
          <TH>Due date</TH>
          <TH>Notes</TH>
        </tr>
      </thead>
      <tbody>
        {hasData && pd7a ? (
          <tr>
            <TD bold>Federal taxes</TD>
            <TD num>
              {pd7a.period_label ||
                pd7a.period_start + " to " + pd7a.period_end}
            </TD>
            <TD>{statusLabel}</TD>
            <TD num bold>
              {money(pd7a.current_payment)}
            </TD>
            <TD num>{pd7a.due_date_display}</TD>
            <TD>Pay by {pd7a.due_date_display}</TD>
          </tr>
        ) : (
          <tr>
            <TD colSpan={6}>Nothing to print for this view.</TD>
          </tr>
        )}
      </tbody>
    </table>
  );
}